import React from 'react'
import {Badge, Button, Input, InputGroup, InputGroupAddon, ListGroup, ListGroupItem} from 'reactstrap'
import RemoveIcon from 'react-icons/lib/fa/close'
import SearchIcon from 'react-icons/lib/fa/search'
import AddIcon from 'react-icons/lib/fa/plus-square-o'
import '../../stylesheets/SearchSelectInput.css'


class SearchSelectInput extends React.Component {
    constructor(props) {
        super(props)

        let {search, placeholder, onChange, initialValue, multipleSelection} = props

        onChange = onChange || ((e) => console.log(e))
        initialValue = initialValue || []

        this.state = {
            selected: initialValue,
            searchResults: [],
            multipleSelection
        }

        this.search = search
        this.placeholder = placeholder
        this.onChange = onChange

        this.handleSearch = this.handleSearch.bind(this)
        this.selectResult = this.selectResult.bind(this)
        this.removeSelected = this.removeSelected.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        let {onChange, multipleSelection} = nextProps

        this.onChange = onChange || ((e) => console.log(e))
        multipleSelection = !(multipleSelection === null || multipleSelection === undefined || multipleSelection === false)

        this.setState({
            searchResults: [],
            multipleSelection: multipleSelection
        })
    }

    async handleSearch(e) {
        e.preventDefault()
        let searchResults = await this.search(this.searchInput.value)
        this.setState({searchResults})
    }

    async selectResult(e, result) {
        e.preventDefault()
        let {selected, multipleSelection} = this.state

        if (multipleSelection) {
            selected.push(result)
        } else {
            selected = [result]
        }
        let searchResults = []

        if (this.searchInput) {
            this.searchInput.value = ""
        }
        await this.setState({selected, searchResults})
        this.onChange(selected)
    }

    async removeSelected(e, result) {
        e.preventDefault()
        let {selected} = this.state
        selected = selected.filter((s) => s !== result)
        await this.setState({selected, searchResults: []})
        this.onChange(selected)
    }

    render() {
        let {selected, searchResults} = this.state
        return <div className="row search-select-input">
            <div className="col-12 ">
                {selected.map((name, idx) =>
                    <Badge key={`selected-${name}-${idx}`} className="align-self-start m-1">
                        {name}
                        <Button onClick={(e)=>this.removeSelected(e, name)}>
                            <RemoveIcon/>
                        </Button>
                    </Badge>)}
            </div>
            <InputGroup className="col-12">
                <Input
                    innerRef={(input) => {
                        this.searchInput = input
                    }}
                    placeholder={this.placeholder}
                    onChange={() => this.setState({searchResults: []})}
                    type="text"/>
                <InputGroupAddon addonType="append">
                    <Button onClick={this.handleSearch}>
                        <SearchIcon/>
                    </Button>
                </InputGroupAddon>
            </InputGroup>
            {searchResults.length ?
                <ListGroup className="search-select-results col-12 no-gutters p-0 m-0">
                    {searchResults.map((name, idx) =>
                        <ListGroupItem key={`search-${name}-${idx}`}
                                         className={`row ${selected.includes(name) ? "selected" : ""}`}>
                            <span className="ellipsize">{name}</span>
                            <Button onClick={(e)=>{selected.includes(name) ? null : this.selectResult(e,name)}} className="float-right">
                                <AddIcon/>
                            </Button>
                        </ListGroupItem>
                    )}
                </ListGroup> :
                null}
        </div>
    }
}

export default SearchSelectInput


// WEBPACK FOOTER //
// ./src/components/ui/SearchSelectInput.js